import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CrudItemComponent, NavItem } from '@hutsix/ngxh6';
import { JobCardInterface } from '../../../../../_generated/api_interfaces/api/jobCard.interface';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-job-dipl',
    templateUrl: './job-dipl.component.html',
    styleUrls: ['./job-dipl.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class JobDiplComponent {
    @Input() public job: Partial<{ referredToDipl: boolean }>;
}
